import React, { createContext, useContext } from 'react';
import { useHistory, useLocation } from 'react-router';
import { filterProviderFactory } from '../../../../../../../../../../../utils/filterProviderFactory';
import { useQueryString } from '../../../../../../../../../../../utils/hooks';

const { Provider, useFilters } = filterProviderFactory();
/**
 * Conversion filters
 */
export const ConversionFiltersProvider = ({ children }) => {
	/**
	 * @param {ConversionFilters.ControlState} controlValues
	 */
	const mapControlsToState = (controlValues) => {
		const { revenueSwitch, fromDate, toDate, ...state } = controlValues;
		return {
			conversionDateGTOE: fromDate,
			conversionDateLTOE: toDate,
			...state,
		};
	};

	return (
		<Provider mapControlsToState={mapControlsToState}>{children}</Provider>
	);
};

export const useConversionFilters = useFilters;
